import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CnCardSubAreaCard } from '@alife/cn-ui';
import uniqBy from 'lodash/uniqBy';
import CnOneSearch from '../cn-one-search';
import useVersionSwitch from '../use-version-switch';
import { formatSuggestionsApiResponse, isValidKey } from '../utils';
// CNUI插件业务配置schema父级
export const pluginExtSchemaPrefix = '__bizExtendConfig__';
// 需要透传给oneSearch的props前缀
export const pluginPropsKeyPrefix = 'COS_';
export function useCnOneSearch(props, context) {
    // const [version, setVersion] = useState('oneSearch');
    const { [`${pluginPropsKeyPrefix}isHiddenHelpDoc`]: isHiddenHelpDoc, [`${pluginPropsKeyPrefix}versionSwitchChange`]: versionSwitchChange, } = props;
    const { isOneSearchVersion, extendButtons } = useVersionSwitch((newIsOneSearchVersion) => {
        const { form, [`${pluginPropsKeyPrefix}translateResults`]: translateResults, onSearch, schema, } = props;
        if (form) {
            form.setValues({}, 'overwrite');
        }
        if (!newIsOneSearchVersion &&
            translateResults &&
            typeof translateResults === 'object' &&
            Object.keys(translateResults).length > 0 &&
            form &&
            typeof onSearch === 'function') {
            const filterParams = {};
            Object.keys(translateResults).forEach((key) => {
                // 判断是否需要设置成数组
                const oldFieldSchema = schema?.properties[key];
                if (oldFieldSchema) {
                    const isSelect = ['CnAsyncSelect', 'Select'].includes(oldFieldSchema['x-component']);
                    const isRangeDatePicker = oldFieldSchema['x-component'] === 'CnRangeDatePickerPro' ||
                        oldFieldSchema['x-component'] === 'RangePicker';
                    const isMultiSelect = isSelect &&
                        oldFieldSchema['x-component-props']?.mode === 'multiple';
                    if ((isSelect && isMultiSelect) || isRangeDatePicker) {
                        filterParams[key] = translateResults[key]?.entityValues || [];
                    }
                    else if (translateResults[key]?.entityValues?.length) {
                        filterParams[key] = translateResults[key]?.entityValues[0];
                    }
                }
            });
            form.setValues(filterParams, 'overwrite');
            onSearch(filterParams);
        }
        if (typeof versionSwitchChange === 'function') {
            versionSwitchChange(newIsOneSearchVersion, context?.state);
        }
    }, isHiddenHelpDoc);
    let finalExtendButtons = [...extendButtons];
    const extendButtonsKey = `${pluginPropsKeyPrefix}extendButtons`;
    if (props[extendButtonsKey]) {
        if (Array.isArray(props[extendButtonsKey])) {
            finalExtendButtons.push(...props[extendButtonsKey]);
        }
        else {
            finalExtendButtons.push(props[extendButtonsKey]);
        }
    }
    // 去重
    finalExtendButtons = uniqBy(finalExtendButtons, 'key');
    return {
        props: {
            ...props,
            isOneSearchVersion,
            [extendButtonsKey]: finalExtendButtons,
        },
        context,
        // render方法用于渲染插件，render方法中不能使用外层的props变量，需要使用innerProps
        render(innerProps, BaseComponent) {
            const { [`${pluginPropsKeyPrefix}useOneSearch`]: useOneSearch, } = innerProps;
            const oneSearchPropsKeys = [
                'className',
                'extendButtons',
                'presetHabitSetting',
                'fetchSuggestApi',
                'fetchSuggest',
                'fieldRender',
                'translateSearchTags',
                'translateResults',
                'bizAccessKey',
                'operatorId',
                'useDefaultTransformFields',
                'customShowLimitNum',
                'isHiddenViewSelector',
                'isDisabledSpaceKeyPress',
                'isSuggestPopupViewTargetInputSearch',
                'defaultSearchTags',
                'onSearchFormat',
            ];
            const sharedPropsKeys = [
                'components',
                'schema',
            ];
            const filterProProps = {
                usePlugin: innerProps.usePlugin,
            };
            const oneSearchProps = {};
            Object.keys(innerProps).forEach((key) => {
                if (isValidKey(key, innerProps)) {
                    const hasPrefix = key.indexOf(pluginPropsKeyPrefix) === 0;
                    const newKey = hasPrefix
                        ? key.replace(pluginPropsKeyPrefix, '')
                        : key;
                    if (hasPrefix && oneSearchPropsKeys.includes(newKey)) {
                        oneSearchProps[newKey] =
                            innerProps[key];
                    }
                    else {
                        filterProProps[newKey] =
                            innerProps[key];
                        if (sharedPropsKeys.includes(newKey)) {
                            oneSearchProps[newKey] =
                                innerProps[key];
                        }
                    }
                }
            });
            if (useOneSearch) {
                const onSearchKeyChange = (searchParams) => {
                    const { onChange } = innerProps;
                    if (typeof onChange === 'function') {
                        onChange({
                            ...searchParams,
                            one_search_flag: true,
                        });
                    }
                };
                const handleSearch = (searchParams) => {
                    const { onSearch, form, onSubmit } = innerProps;
                    if (form) {
                        form.setValues(searchParams, 'overwrite');
                    }
                    if (typeof onSearch === 'function') {
                        onSearch({
                            ...searchParams,
                            one_search_flag: true,
                        });
                    }
                    if (typeof onSubmit === 'function') {
                        onSubmit({
                            ...searchParams,
                            one_search_flag: true,
                        });
                    }
                };
                const { COS_fetchSuggestApiConfig: fetchSuggestApiConfig } = props;
                if (fetchSuggestApiConfig &&
                    Object.keys(fetchSuggestApiConfig).length &&
                    typeof oneSearchProps.fetchSuggest !== 'function' &&
                    window.cnLowCodeUtils?.request?.makeRequest) {
                    oneSearchProps.fetchSuggest = async (keyword, bizAccessKey) => {
                        return window.cnLowCodeUtils.request
                            .makeRequest({
                            buttonConfig: {
                                options: {
                                    requestConfig: fetchSuggestApiConfig,
                                },
                            },
                            recordDataSource: {},
                            state: {},
                            handleParams: () => {
                                return {
                                    keyword,
                                    bizAccessKey,
                                };
                            },
                            needSuccessToast: false,
                        })
                            .then((res) => {
                            return formatSuggestionsApiResponse(res);
                        });
                    };
                }
                return (_jsxs(_Fragment, { children: [_jsx(CnOneSearch, { ...oneSearchProps, onSearchKeyChange: onSearchKeyChange, onSearch: handleSearch, disabled: !innerProps.isOneSearchVersion }), !innerProps.isOneSearchVersion && (_jsx(CnCardSubAreaCard, { className: 'cn-one-search-normal-filter-container', children: _jsx(BaseComponent, { ...filterProProps }) }))] }));
            }
            return _jsx(BaseComponent, { ...innerProps });
        },
    };
}
